import React from 'react';
import PropTypes from 'prop-types';
import ToolSelectComponent from '../tool-select-base/tool-select-base.jsx';
import messages from '../../lib/messages.js';
import selectIcon from './marquee.svg';

const BitSelectComponent = (props) => (
  <ToolSelectComponent
    imgDescriptor={messages.select}
    imgSrc={selectIcon}
    isSelected={props.isSelected}
    onMouseDown={props.onMouseDown}
    keybinding="S"
  />
);

BitSelectComponent.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onMouseDown: PropTypes.func.isRequired
};

export default BitSelectComponent;
